(($) => {
  Drupal.behaviors.hamburgerMenu = {
    attach(context) {
      const toggleExpand = $('#toggle-expand', context);
      const menu = $('#hamburger-nav', context);
      const menuNav = $('.burger-nav', context);
      const body = $(document.body);

      if (menu) {
        // const expandMenu = menu.getElementsByClassName('expand-sub');

        // Mobile Menu Show/Hide.
        toggleExpand.once('click').on('click', (e) => {
          toggleExpand.toggleClass('toggle-expand__burger-button--open');
          menu.toggleClass('primary-menu__one--open');
          menuNav.toggleClass('burger-nav--open');
          body.toggleClass('body-overlay');
          e.preventDefault();
        });

        // Expose mobile sub menu on click.
        // for (let i = 0; i < expandMenu.length; i += 1) {
        //   expandMenu[i].addEventListener('click', (e) => {
        //     const menuItem = e.currentTarget;
        //     const subMenu = menuItem.nextElementSibling;

        //     menuItem.classList.toggle('expand-sub--open');
        //     subMenu.classList.toggle('hamburger-menu--sub-open');
        //   });
        // }
      }
    },
  };
})(jQuery);
